module.exports = __webpack_public_path__ + "static/toys-3-2230a206a9f7d9f657466e50340fe9c1.jpg";